import { ButtonTypes } from "../../../../../../components/ui/Button";
import { Icon, IconSymbols } from "../../../../../../components/ui/Icon";
import { Panel } from "../../../../../../components/ui/Panel";
import { ProcessTemplateSelection } from "../../../../../../pages/change/organisations/settingsView/processesSettings/modals/ProcessTemplateSelection_view";
import { SystemProcessUploader } from "../../../../../../pages/insight/projects/Processes/ProcessListView/modals/SystemProcessUploader/SystemProcessUploader_view";
import I18n from "../../../../../localization/I18n";
import ModalContext from "../../../../../modalZ/context/ModalContext";
import { Animations } from "../../../../../util/Animations";
import { gridSideModalComponentProps } from "../../../../GridSideModals";
import { ProcessesGrid } from "./ProcessesGridView_view";

export const SHOW_ADD_PROCESSES_FROM_TEMPLATE_MODAL = (
  projectId: number,
  template: any,
  isCompactGrid: boolean,
  onAssignSuccess: any
) => {
  ModalContext.show({
    showClose: false,
    title: null,
    content: (
      <ProcessTemplateSelection
        template={template}
        projectId={projectId}
        onAssignSuccess={onAssignSuccess}
        isCompactGrid={isCompactGrid}
      ></ProcessTemplateSelection>
    ),
    componentProps: {
      wrapHeight: "default",
      wrapWidth: "large",
      position: "middle",
      className: "modal__process-template"
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    }
  });
};

export const SHOW_ADD_PROCESSES_FROM_TEMPLATE_MODAL_CONFIG = (
  data: any,
  onAssignSuccess: any,
  selectedLinkItems: any
) => {
  return {
    showClose: false,
    title: null,
    content: (
      <ProcessesGrid
        data={data}
        gridToolbarType="link-modal"
        onAssignSuccess={onAssignSuccess}
        selectedLinkItems={selectedLinkItems}
      ></ProcessesGrid>
    )
  };
};

export const SHOW_PROCESS_DELETE_CONFIRM_MODAL = (
  itemIds: number[],
  removeItems: (itemIds: number[]) => Promise<any>
) => {
  return new Promise(resolve => {
    ModalContext.showConfirmDialog(
      <h1 className="mt-4">{I18n.t("phrases.confirm")}</h1>,
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12">
            <Icon symbol={IconSymbols.AlertCircle} className="mr-2" />
            {I18n.t("warnings.removeProcessFromOrg")}
          </div>
        </div>
        <div className="row">
          <div className="col">{I18n.t("phrases.confirmProcessRangeRemove", { name: itemIds.length + "" })}</div>
        </div>
      </div>,
      I18n.t("phrases.yes"),
      I18n.t("phrases.no"),
      {
        wrapWidth: "small",
        spacing: "small",
        position: "middle",
        panelProps: {
          background: Panel.PanelBackgrounds.BG_WHITE
        }
      },
      async () => {
        ModalContext.hide();
        await removeItems(itemIds);
        resolve(true);
      },
      () => {
        ModalContext.hide();
      },
      ButtonTypes.DANGER
    );
  });
};

export const SHOW_PROCESS_UPLOADER_MODAL = (reloadProcessesFn: () => void) => {
  ModalContext.show({
    showClose: true,
    title: null,
    content: <SystemProcessUploader onProcessesCreated={reloadProcessesFn} />,
    componentProps: {
      ...gridSideModalComponentProps,
      wrapHeight: "default",
      wrapWidth: "large",
      position: "middle"
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    }
  });
};
